/* ShoppingIL 2026: phase switch (before / live / ended), countdown, copy code.
   Pages may be cached, so the phase is re-checked here in the browser. */
(() => {
  const body = document.body;
  const start = Date.parse(body.dataset.silStart || '');
  const end = Date.parse(body.dataset.silEnd || '');
  const autoOff = body.hasAttribute('data-sil-auto-off');
  if (Number.isNaN(start) || Number.isNaN(end)) return;

  const pad = (n) => String(n).padStart(2, '0');
  const timers = [...document.querySelectorAll('[data-sil-countdown]')].map((el) => ({
    d: el.querySelector('[data-sil-d]'),
    h: el.querySelector('[data-sil-h]'),
    m: el.querySelector('[data-sil-m]'),
    s: el.querySelector('[data-sil-s]')
  }));

  const setPhase = (phase) => {
    if (body.classList.contains('sil-' + phase)) return;
    body.classList.remove('sil-before', 'sil-live', 'sil-ended', 'sil-off');
    body.classList.add('sil-' + phase);
    // the landing page itself sends visitors to the shop once the event is over
    const page = document.querySelector('[data-sil-page]');
    if (phase === 'ended' && page && !window.Shopify?.designMode) location.replace(page.dataset.silPage);
  };

  let timer;
  const tick = () => {
    const now = Date.now();
    let target;
    if (now < start) { setPhase('before'); target = start; }
    else if (now <= end) { setPhase('live'); target = end; }
    else {
      if (autoOff) setPhase('ended');
      target = now;
      clearInterval(timer);
    }
    const left = Math.max(0, Math.floor((target - now) / 1000));
    const d = Math.floor(left / 86400);
    const h = Math.floor((left % 86400) / 3600);
    const m = Math.floor((left % 3600) / 60);
    const s = left % 60;
    timers.forEach((t) => {
      if (t.d) t.d.textContent = pad(d);
      if (t.h) t.h.textContent = pad(h);
      if (t.m) t.m.textContent = pad(m);
      if (t.s) t.s.textContent = pad(s);
    });
  };
  tick();
  timer = setInterval(tick, 1000);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sil-copy]');
    if (!btn) return;
    const code = btn.getAttribute('data-sil-copy');
    const done = () => {
      const note = btn.querySelector('[data-sil-copied]');
      if (!note) return;
      note.hidden = false;
      setTimeout(() => { note.hidden = true; }, 2000);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(done, () => {});
    }
  });
})();
